import {configParamsModule} from "./configParamsModule";
import {IHttpService, IPromise} from "angular";
import {PersistentProxyConfiguration} from "./model/persistentProxyConfiguration";
import {RemoteServicesConfigParams} from "./model/remoteServicesConfigParams";
import {MutableConfigParams} from "./model/mutableConfigParams";
import {integration, server} from "../server";
import {userManagementServer} from "../userManagementServer";
import {ExceptionMessage, PatchInfo} from "../../bower_components/front-end-web-commons";
import {PermissionGroupCreateParams} from "./permissionGroup/create/PermissionGroupCreateParams";
import {PermissionGroupInfo} from "./permissionGroup/create/nlgPermissionGroupCreate";
import {PathProvider} from "./model/PathProvider";

export interface BiModel {
    id: number | null,
    segment: string,
    profile: string,
    company: string,
    product: string,
    quantityOfLicenses: number,
    allowedUsers: []
}
export class ConfigParamsService {
    constructor(private $http: IHttpService, private remoteServerService: any) {
    }

    getConfigParams(): IPromise<MutableConfigParams> {
        return this.$http.get<MutableConfigParams>(server.getServiceUrl("config-params")).then(response => response.data);
    }

    getRemoteServicesConfigParams(): IPromise<RemoteServicesConfigParams[]> {
        return this.remoteServerService.getRemoteServicesConfigParams();
    }

    updateRemoteServicesConfigParams(remoteServicesConfigParams: RemoteServicesConfigParams[]): IPromise<void> {
        return this.remoteServerService.updateRemoteServicesConfigParams(remoteServicesConfigParams);
    }

    getDefaultProxyConfig() {
        return this.$http.get<PersistentProxyConfiguration>(server.getServiceUrl("config-params.default-proxy")).then(response => response.data);
    }

    getDefaultRemoteServer() {
        return this.$http.get<RemoteServicesConfigParams>(server.getServiceUrl("config-params.default-remote-server")).then(response => response.data);
    }

    clearServerCache() {
        return this.$http.delete<void>(server.getServiceUrl("config-params.cache")).then(response => response.data);
    }

    clearIntegrationCache() {
        return this.$http.delete<void>(integration.getServiceUrl("cache")).then(response => response.data);
    }

    validateRemoteServicesConfigParams(remoteServices: RemoteServicesConfigParams[]) {
        return this.$http.post<void>(server.getServiceUrl("config-params.validate-remote-services"), remoteServices).then(response => response.data);
    }

    checkForScript(numberOfRow: number): IPromise<void> {
        return this.$http.post<void>(server.getServiceUrl("config-params.check-for-script"), numberOfRow).then(response => response.data);
    }

    updateConfigParams(patches: PatchInfo[], version: number) {
        return this.$http.post<void>(server.getServiceUrl("config-params.update"), patches, {params: {version}}).then(response => response.data);
    }

    updateIgnoringWarnings(patches: PatchInfo[], version: number) {
        return this.$http.post<void>(server.getServiceUrl("config-params.update-ignoring-warnings"), patches, {params: {version}}).then(response => response.data);
    }

    testRoutingConnection(remoteServicesSet: RemoteServicesConfigParams[]) {
        return this.$http.post<ExceptionMessage>(server.getServiceUrl("config-params.test-routing-connection"), remoteServicesSet).then(response => response.data);
    }

    findPermissionGroupsBySourceId(params: string) {
        return this.$http.post<any[]>(userManagementServer.getServiceUrl("permission-group.find"), {
            params: {
                string: params
            }
        }).then(response => response.data)
    }

    createPermissionGroup(params: PermissionGroupCreateParams) {
        return this.$http.post<any[]>(userManagementServer.getServiceUrl("permission-group"), params)
            .then(response => response.data)
    }

    getInfo(params: any) {
        return this.$http.post<PermissionGroupInfo>(userManagementServer.getServiceUrl("permission-group-get-info"),
            params
        ).then(response => response.data)
    }

    getPathProviderType() {
        return this.$http.get<PathProvider>(server.getServiceUrl("config-params.get-path-provider-type"))
            .then(response => response.data)
    }

    getPathProviderTypes() {
        return this.$http.get<string>(server.getServiceUrl("config-params.get-path-provider-types"))
            .then(response => response.data)
    }

    updatePathProvider(params: PathProvider) {
        return this.$http.post<PermissionGroupInfo>(server.getServiceUrl("config-params.set-path-provider"),
            params
        ).then(response => response.data)
    }
}

configParamsModule.service("configParamsService", ConfigParamsService)